import cloneDeep from 'lodash.clonedeep';

const displayMode = () => {
  // Account for both desktop browsers and Safari. For more info, see link below - ETC
  // https://developers.google.com/web/fundamentals/app-install-banners#detect-mode
  if (window.matchMedia('(display-mode: standalone)')?.matches
        || window.navigator.standalone === true) {
    return 'standalone';
  }

  return 'browser';
};

const telemetryUserAttributes = (currentUser) => {
  if (import.meta.env.NODE_ENV === 'test') {
    return {
      email: 'testemail@testemail.com',
      user_id: 123456,
      dealer_type: 'franchise',
      dealer_id: 654321,
      web_version: import.meta.env.VITE_VERSION,
      build_date: import.meta.env.VITE_BUILD_DATE,
      user_agent: navigator.userAgent,
      display_mode: displayMode(),
    };
  }

  return {
    email: currentUser.email,
    userId: currentUser.user_id,
    user_id: currentUser.user_id,
    dealer_type: currentUser.dealer_type,
    dealer_id: currentUser.defaultDealerId,
    web_version: import.meta.env.VITE_VERSION,
    build_date: import.meta.env.VITE_BUILD_DATE,
    user_agent: navigator.userAgent,
    display_mode: displayMode(),
  };
};

const addAppSpecificData = (data) => {
  if (!data) return data;

  return {
    vue_spa: true,
    web_version: import.meta.env.VITE_VERSION,
    build_date: import.meta.env.VITE_BUILD_DATE,
    ...cloneDeep(data),
  };
};

export { telemetryUserAttributes, displayMode, addAppSpecificData };
